import React from "react";
import { Video } from "~/common/MediaViewerV2/model";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";

interface VideoMediaRendererProps {
  index: number;
  selectedMediaIndex: number;
  video: Video;
}

const VideoMediaRenderer = ({
  index,
  selectedMediaIndex,
  video,
}: VideoMediaRendererProps) => (
  <div className="flex items-center h-full w-full">
    <div className="w-full h-full relative">
      <ZestVideoPlayer
        videoSection="Gallery"
        posterImage={video.poster}
        sources={video.sources}
        currentIndex={index}
        selected={selectedMediaIndex}
        title={video.title}
        youtubeId={video.youtubeId}
        closedCaptionsrc={video.closedCaptionFile}
        playsInline
      />
    </div>
  </div>
);

export default VideoMediaRenderer;
